import { AddMachine } from '@features/Contractor/Machine/Add'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const AddMachineRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  return <AddMachine contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/machines/add')({
  component: AddMachineRoute,
  staticData: {
    breadcrumb: t('contractor.addMachine.title'),
  },
})
